export default "__VITE_ASSET__CqwGgb1z__"